class TeamCard {
  constructor(card) {
    this.card = card;
    this.triggers = card.querySelectorAll('.team-card-toggle-trigger');
    this.init();
  }

  init() {
    if (!this.triggers.length) return;
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.handleToggle());
    });
  }

  handleToggle() {
    const isExpanded = this.card.classList.toggle('is-expanded');
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(isExpanded));
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.team-card').forEach((card) => {
    // eslint-disable-next-line no-new
    new TeamCard(card);
  });
});
